var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQcShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#73AB8B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 18.6666L20.0003 19.9999L22.667 17.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.6667V13.3333C21.9998 13.0995 21.938 12.8699 21.821 12.6675C21.704 12.465 21.5358 12.2969 21.3333 12.18L16.6667 9.51335C16.464 9.39633 16.234 9.33472 16 9.33472C15.766 9.33472 15.536 9.39633 15.3333 9.51335L10.6667 12.18C10.4642 12.2969 10.296 12.465 10.179 12.6675C10.062 12.8699 10.0002 13.0995 10 13.3333V18.6667C10.0002 18.9005 10.062 19.1301 10.179 19.3326C10.296 19.535 10.4642 19.7031 10.6667 19.82L15.3333 22.4867C15.536 22.6037 15.766 22.6653 16 22.6653C16.234 22.6653 16.464 22.6037 16.6667 22.4867L18 21.7267M13 10.8467L19 14.28",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1934 12.6666L16 16M16 16L21.8067 12.6666M16 16V22.6666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQcShipping);
export default __webpack_public_path__ + "static/media/qc_shipping.dfbd67957871e98ed5be0bd4f3f0b6d5.svg";
export { ForwardRef as ReactComponent };